var TYPE;
(function (TYPE) {
    TYPE["DANGER"] = "danger";
    TYPE["PRIMARY"] = "primary";
    TYPE["WARNING"] = "warning";
    TYPE["SUCCESS"] = "success";
})(TYPE || (TYPE = {}));

export { TYPE };
